import { formatISO } from 'date-fns';
import { z } from 'zod';

import { nullishString } from '../../utils/schema';

const nullishNumber = () =>
  z.preprocess(
    (val) => (typeof val === 'string' ? Number(val) : val),
    z.number().nullish(),
  );

const today = () => formatISO(new Date(), { representation: 'date' });
const dateString = z.string().trim().date();

export const AgllcBulkDonorScheduleRowSchema = z.object({
  priority: nullishNumber(),
  donorNameToMatch: z.string().min(1).max(41),
  pen: nullishString(),
  donorRegistrationNumber: nullishString({ max: 20 }),
  donorBreed: z.string().min(1),
  birthDate: dateString
    .refine((value) => value <= today(), {
      message: 'Birth date cannot be in the future',
    })
    .nullish(),
  psi: nullishNumber(),
  gnm: nullishNumber(),
  gcm: nullishNumber(),
  pregnant: z.boolean().nullish(),
  programName: nullishString({ max: 100 }),
  opuDate: dateString
    .refine((value) => value >= today(), {
      message: 'OPU date cannot be in the past',
    })
    .nullish(),
  opuSite: nullishString(),
  sire: nullishString(),
  naab: nullishString({ max: 10 }),
  sir1Psi: nullishNumber(),
  semenType: nullishString(),
  collectionCode: nullishString(),
  backupSire: nullishString(),
  backupNaab: nullishString({ max: 10 }),
  sir2Psi: nullishNumber(),
  backupSemenType: nullishString(),
  donorResolution: z
    .enum(['USE_EXISTING', 'CREATE_NEW'])
    .nullish()
    .transform((value) => value ?? null),
});

export const AgllcBulkDonorScheduleRowsSchema = z.array(
  AgllcBulkDonorScheduleRowSchema.nullish().transform((row) => row ?? null),
);

export type AgllcBulkDonorScheduleInput = z.infer<
  typeof AgllcBulkDonorScheduleRowSchema
>;

export const AgllcBulkDonorScheduleFieldsSchema = z.object({
  fertilizationSiteId: z.string().min(1),
});

export type AgllcBulkDonorScheduleFieldsInput = z.infer<
  typeof AgllcBulkDonorScheduleFieldsSchema
>;
